import { ArrowRightIcon, CircleAlert } from 'lucide-react';

import triviaBgNoText from '@/assets/trivia-bg--no-text-mob.jpg';
import { Button } from '@/components';

export const ClosedTrivias = ({
  played,
  handleShowStats,
}: {
  played: boolean;
  handleShowStats: () => void;
}) => {
  return (
    <>
      <div className="w-full flex flex-col h-full">
        <img
          alt="Trivia"
          className="w-full h-36 object-cover flex md:hidden"
          loading="lazy"
          src={triviaBgNoText}
        />
        <div className="py-9 px-10 flex flex-col gap-y-3   bg-white rounded-r-lg h-full justify-center">
          <div className="p-2 bg-gdt-blue-light2 rounded-full w-fit">
            <CircleAlert className="stroke-gdt-blue" size={20} />
          </div>
          <h2 className="text-xl font-bold  ">Finalizaron las trivias.</h2>
          {played && <span>¡Gracias por participar!</span>}

          {played && (
            <Button
              className="mt-4 flex font-bold no-underline mx-auto items-center space-x-2 hover:text-gdt-blue"
              type="button"
              variant="text"
              onClick={handleShowStats}
            >
              <span> Ver estadísticas totales</span>
              <ArrowRightIcon className="stroke-gdt-blue self-end" size={22} />
            </Button>
          )}
        </div>
      </div>
    </>
  );
};
